import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import { setTosAndDataPrivacy, setAuthorizationHybris, displayLoader, getCustomerSession, setCustomerInfo, showConfirmLogin, showBahagSignIn, showBahagSignUp, showBahagForgetPassword, login } from '../actions/Bahag.action';
import { setCookie } from "../Components/AB-test-read-more";
import BahagTerms from './BahagTerms';
class BahagSignIn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowWrongMessage: false,
            errorMessage: "",
        };

        this.emailInput = React.createRef();
        this.passwordInput = React.createRef();
    }

    renderSignIn() {
        return (
            <>
                <h3 id="bahag-signin" className="checkout__section-title">{translate('checkout.bahag.signin.header')}</h3>
                <div className="germany-section__signin">
                    <span></span>
                    <p className="germany-section__signin--header">{translate("checkout.bahag.login.title")}</p>
                    <p className="germany-section__signin--subheader">{translate("checkout.bahag.login.description")} </p>
                    <form onSubmit={(event) => this.handleLogin(event)}>
                        <div className="germany-section__signin-form">
                            <div className="germany-section__signin-form--input-container">
                                <input type="email" required placeholder={translate('checkout.bahag.signin.placeholder.email')} ref={this.emailInput}></input>
                                <input type="password" required placeholder={translate('checkout.signin.placeholder.password')} ref={this.passwordInput}></input>
                            </div>
                            {this.state.isShowWrongMessage && (
                                <div className="germany-section__signin--fail">
                                    <p>{this.state.errorMessage}</p>
                                </div>
                            )}
                            <div className="germany-section__signin--buttons">
                                <a onClick={() => this.props.showBahagForgetPassword()}>{translate('checkout.bahag.forget.password.button')}</a>
                                <button className="germany-section__signin--buttons--signin" type="submit">
                                    {translate('checkout.bahag.signin.button')}
                                </button>
                                <span className="germany-section__separator-line"></span>
                                <button className="germany-section__signin--buttons--signup" onClick={() => this.props.showBahagSignUp()}>
                                    {translate('checkout.bahag.signup.button')}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <BahagTerms />
            </>
        )
    }

    async handleLogin(event) {
        event.preventDefault();
        let tosAndDataPrivacyCheckBoxChecked = this.props.isTosAndDataPrivacyChecked

        if (tosAndDataPrivacyCheckBoxChecked) {
            this.setState({ isShowWrongMessage: false })
            const email = this.emailInput.current.value;
            const password = this.passwordInput.current.value;
            this.props.displayLoader(true);
            let loginData = await this.props.login(email, password);
            if (loginData && loginData.customer_id) {
                this.props.displayLoader(false);
                this.setState({ isShowWrongMessage: false })
                this.props.showConfirmLogin();
                await this.props.setCustomerInfo(loginData);
                const authorizationHybris = loginData.authorizationHybris;
                this.props.setAuthorizationHybris(authorizationHybris);
                setCookie("authorizationHybris", authorizationHybris, 20);

            } else {
                this.setState({ isShowWrongMessage: true, errorMessage: translate("checkout.signin.error.message") })
                this.props.displayLoader(false);
            }
        } else {
            this.setState({ isShowWrongMessage: true, errorMessage: translate("checkout.bahag.signin.error.message.checkbox") })
        }
    }

    render() {
        return (
            <div>
                {this.renderSignIn()}
            </div>
        );
    }
}


const mapDispatchToProps = (dispatch) => ({
    showConfirmLogin: () => dispatch(showConfirmLogin(true)),
    showBahagSignIn: () => dispatch(showBahagSignIn(true)),
    showBahagSignUp: () => dispatch(showBahagSignUp(true)),
    showBahagForgetPassword: () => dispatch(showBahagForgetPassword(true)),
    login: (email, password) => dispatch(login(email, password)),
    setCustomerInfo: (customerInfo) => dispatch(setCustomerInfo(customerInfo)),
    getCustomerSession: (customerId) => dispatch(getCustomerSession(customerId)),
    displayLoader: (isLoaderActive) => dispatch(displayLoader(isLoaderActive)),
    setAuthorizationHybris: (authorizationHybris) => dispatch(setAuthorizationHybris(authorizationHybris)),
    setTosAndDataPrivacy: (checked) => dispatch(setTosAndDataPrivacy(checked)),
});

const mapStateToProps = state => {
    return {
        isTosAndDataPrivacyChecked: state.bahag.isTosAndDataPrivacyChecked
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BahagSignIn);
